import React from "react";

import { Form } from "antd";
import { FormInstance } from "antd/lib/form";

import { CompanyInfo } from "../../../../bitmaker/schemas/Billing/CompanyInfo";

import { InvoiceItemsList } from "./ContentPanel/InvoiceItemsList";
import { InvoiceSummaryTotals } from "./ContentPanel/InvoiceSummaryTotals";
import { InvoiceNotesTerms } from "./ContentPanel/InvoiceNotesTerms";

interface InvoiceContentPanelProps {
  form: FormInstance;
  companyInfo: CompanyInfo | null;
  isEditMode: boolean;
}

export const InvoiceContentPanel: React.FC<InvoiceContentPanelProps> = ({
  form,
  companyInfo,
  isEditMode,
}) => {
  const language = Form.useWatch("language", form);

  const texts = {
    itemsTitle: language === "es" ? "Ítems y Servicios" : "Items & Services",
  };

  return (
    <div className="col-span-9 grid grid-cols-12 py-4 border-r border-dashed border-gray-300">
      {/* Title */}
      <h3 className="text-base font-semibold border-b pb-2 col-span-10 mb-4">
        {texts.itemsTitle}
      </h3>
      {/* Items */}
      <InvoiceItemsList form={form} />
      <div className="border-b border-dashed border-gray-400 mt-6 mb-6 col-span-10"></div>
      {/* Summary of totals */}
      <InvoiceSummaryTotals form={form} />
      {/* Terms */}
      <InvoiceNotesTerms
        form={form}
        companyInfo={companyInfo}
        isEditMode={isEditMode}
      />
    </div>
  );
};
